class MediaQuery {
	constructor() {
		this.BREAKPOINTS = {
			XS: 0,
			SM: 576,
			MD: 768,
			LG: 992,
			XL: 1200
		};
	}

	breakpointMaxWidth(breakpoint) {
		let width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

		if(_.isFinite(breakpoint)) {
			return breakpoint > width;
		}
		console.error(`MediaQuery::Error`, 'Please supply a valid breakpoint');
		return false;
	}
}

export let mediaQuery = new MediaQuery();
